import {
  useCallback, useState 
} from "react";

const useMobileFilterModal = (props) => {
  const {
    onClose,
    selectedColorIds: propsSelectedColorIds,
    selectedCategoryId: propsSelectedCategoryId,
    onReset,
    onApply
  } = props;

  const [selectedColorIds, setSelectedColorIds] = useState(propsSelectedColorIds);

  const [selectedCategoryId, setSelectedCategoryId] = useState(propsSelectedCategoryId);

  const [activeFilter, setActiveFilter] = useState("category");

  const handleClose = useCallback(() => {
    onClose();
  }, [onClose]);

  const handleReset = useCallback(() => {
    setSelectedColorIds("");
    setSelectedCategoryId("");
  }, []);

  const applyFilters = useCallback(() => {
    onApply(selectedColorIds, selectedCategoryId);
    onClose();
  }, [onApply, selectedColorIds, selectedCategoryId, onClose]);

  return {
    handleClose,
    activeFilter,
    selectedColorIds,
    setSelectedColorIds,
    selectedCategoryId,
    setSelectedCategoryId,
    setActiveFilter,
    handleReset,
    applyFilters
  };
};

export default useMobileFilterModal;
